<template>
    <div>
        <div v-if="false" style="display: flex; justify-content: flex-end; padding: 10px 0">
            <el-button-group>
                <template v-if="canEdit">
                    <!-- <el-button size="mini" @click="editClick">{{ canEdit ? '取消' : '修改' }}</el-button> -->
                    <el-button v-show="canEdit" size="mini" type="primary" @click="saveData">保存</el-button>
                </template>
            </el-button-group>
        </div>
        <div style="display: flex; justify-content: center">
            <div style="width: 220px; padding: 10px">
                <span class="required">*</span>
                学 校：{{ formData.institutionName }}
            </div>
            <div style="width: 220px; padding: 10px">
                <span class="required">*</span>
                年 级：{{ formData.admissionYear }}
            </div>
            <div style="width: 220px; padding: 10px">
                <span class="required">*</span>
                班 别：{{ formData.className }}
            </div>
            <div style="width: 300px; padding: 10px">
                <span class="required">*</span>
                学(籍)号：{{ formData.studentFileId }}
            </div>
        </div>
        <div class="knxsrdb">
            <table class="grid" cellspacing="0" cellpadding="0">
                <thead>
                    <!-- <tr>
					<th class="title" colspan="12">{{ formData.title || '广东省家庭经济困难学生认定申请表' }}</th>
				</tr> -->
                </thead>
                <tbody>
                    <tr>
                        <td class="section" :rowspan="7">学生基本情况</td>
                        <td class="label">
                            <span class="required">*</span>
                            姓名
                        </td>
                        <td class="el-table__cell tdcont tdw83" colspan="2">
                            <form-item
                                key="student"
                                ref="studentName"
                                :field="{
                                    defaultValue: null,
                                    elementCanEdit: 1,
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 1,
                                    elementType: 'input',
                                    emptyMessage: '请选择姓名',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onClickEvent: '',
                                    passenger: {},
                                    propComment: '姓名',
                                    propName: 'name',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: null,
                                    valueMinLength: null,
                                    model: 'formData.name',
                                    option: [],
                                    dialog: 1,
                                    dialogType: 'listpage',
                                    dialogMultiple: false,
                                    dialogListviewurl: 'student.basicInfo.list?urlsearch=' + urlsearch,
                                    dialogTitle: '选择姓名'
                                }"
                                :vo="formData"
                            />
                        </td>
                        <td class="label">性别</td>
                        <td colspan="2">{{ formData.gender == 1 ? '女' : '男' }}</td>
                        <td class="label">民族</td>
                        <td colspan="2">{{ formData.ethnicity }}</td>
                        <td class="label">出生年月</td>
                        <td colspan="2">
                            {{ formData.birthDate ? moment(formData.birthDate).format('YYYY-MM') : '' }}
                        </td>
                    </tr>
                    <tr>
                        <td class="label">身份证号</td>
                        <td colspan="5">{{ formData.idCardNumber }}</td>
                        <td class="label">户口性质</td>
                        <td colspan="5">
                            <!-- {{ vo.hukouNature }} -->
                            <form-item
                                ref="hukouNature"
                                :field="{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: '城镇：城镇\n农村：农村',
                                    elementReadonly: 1,
                                    elementType: 'radio',
                                    emptyMessage: '请选择户口性质',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 8,
                                    isRequired: 1,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '户口性质',
                                    propName: 'hukouNature',
                                    propType: 'String',
                                    textFormatter: null,
                                    valueMaxLength: 50,
                                    valueMinLength: null,
                                    model: 'formData.hukouNature',
                                    option: [
                                        { value: '城镇', name: '城镇' },
                                        { value: '农村', name: '农村' },
                                    ],
                                    optionGenerateType: 0,
                                    clearable: false,
                                    filterable: false,
                                    allowCreate: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />
                        </td>
                    </tr>
                    <tr>
                        <td class="label">
                            院系
                            <br />
                            (只需高校学生填写)
                        </td>
                        <td colspan="5">{{ formData.majorCategory }}</td>
                        <td class="label">
                            专业
                            <br />
                            (只需高校学生填写)
                        </td>
                        <td colspan="5">{{ formData.majorSubcategory }}</td>
                    </tr>
                    <tr>
                        <td class="section" :rowspan="3">
                            家庭情况
                        </td>
                        <td class="label"> <span class="required">*</span>家庭人口数</td>
                        <td colspan="4">
                            <form-item
                                v-if="canEdit"
                                ref="population"
                                :field="{
                                    cssClass: null,
                                    cssStyle: null,
                                    defaultValue: null,
                                    elementCanEdit: '{{canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 0,
                                    elementType: 'input',
                                    emptyMessage: '请输入家庭人口数',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onBlurEvent: null,
                                    onChangeEvent: null,
                                    onClickEvent: null,
                                    onDblClickEvent: null,
                                    onFocusEvent: null,
                                    onKeyDownEvent: null,
                                    onKeyPressEvent: null,
                                    onKeyUpEvent: null,
                                    onMouseDownEvent: null,
                                    onMouseOverEvent: null,
                                    onMouseUpEvent: null,
                                    passenger: {},
                                    propComment: '家庭人口数',
                                    propName: 'population',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 500,
                                    valueMinLength: null,
                                    model: 'formData.population',
                                    option: [],
                                    dialog: 0,
                                    autocomplete: 'off',
                                    showWordLimit: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />

                            <!-- <el-input v-if="canEdit" v-model="formData.population" size="mini" resize="none" placeholder="请输入家庭人口数"></el-input> -->
                            <span v-else>{{ formData.population }}</span>
                        </td>
                        <td class="label"><span class="required">*</span>家庭成员在学人数</td>
                        <td colspan="5">
                            <form-item
                                v-if="canEdit"
                                ref="learningNum"
                                :field="{
                                    cssClass: null,
                                    cssStyle: null,
                                    defaultValue: null,
                                    elementCanEdit: '{{canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 0,
                                    elementType: 'input',
                                    emptyMessage: '请输入家庭成员在学人数',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onBlurEvent: null,
                                    onChangeEvent: null,
                                    onClickEvent: null,
                                    onDblClickEvent: null,
                                    onFocusEvent: null,
                                    onKeyDownEvent: null,
                                    onKeyPressEvent: null,
                                    onKeyUpEvent: null,
                                    onMouseDownEvent: null,
                                    onMouseOverEvent: null,
                                    onMouseUpEvent: null,
                                    passenger: {},
                                    propComment: '家庭成员在学人数',
                                    propName: 'learningNum',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 500,
                                    valueMinLength: null,
                                    model: 'formData.learningNum',
                                    option: [],
                                    dialog: 0,
                                    autocomplete: 'off',
                                    showWordLimit: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="formData.learningNum" size="mini" resize="none" placeholder="请输入家庭成员在学人数"></el-input> -->
                            <span v-else>{{ formData.learningNum }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="label"><span class="required">*</span>赡养人数</td>
                        <td colspan="4">
                            <form-item
                                v-if="canEdit"
                                ref="supportNum"
                                :field="{
                                    cssClass: null,
                                    cssStyle: null,
                                    defaultValue: null,
                                    elementCanEdit: '{{canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 0,
                                    elementType: 'input',
                                    emptyMessage: '请输入赡养人数',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onBlurEvent: null,
                                    onChangeEvent: null,
                                    onClickEvent: null,
                                    onDblClickEvent: null,
                                    onFocusEvent: null,
                                    onKeyDownEvent: null,
                                    onKeyPressEvent: null,
                                    onKeyUpEvent: null,
                                    onMouseDownEvent: null,
                                    onMouseOverEvent: null,
                                    onMouseUpEvent: null,
                                    passenger: {},
                                    propComment: '赡养人数',
                                    propName: 'supportNum',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 500,
                                    valueMinLength: null,
                                    model: 'formData.supportNum',
                                    option: [],
                                    dialog: 0,
                                    autocomplete: 'off',
                                    showWordLimit: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="formData.supportNum" size="mini" resize="none" placeholder="请输入赡养人数"></el-input> -->
                            <span v-else>{{ formData.supportNum }}</span>
                        </td>
                        <td class="label"><span class="required">*</span>家庭成员失业人数</td>
                        <td colspan="5">
                            <form-item
                                v-if="canEdit"
                                ref="unemploymentNum"
                                :field="{
                                    cssClass: null,
                                    cssStyle: null,
                                    defaultValue: null,
                                    elementCanEdit: '{{canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 0,
                                    elementType: 'input',
                                    emptyMessage: '请输入家庭成员失业人数',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onBlurEvent: null,
                                    onChangeEvent: null,
                                    onClickEvent: null,
                                    onDblClickEvent: null,
                                    onFocusEvent: null,
                                    onKeyDownEvent: null,
                                    onKeyPressEvent: null,
                                    onKeyUpEvent: null,
                                    onMouseDownEvent: null,
                                    onMouseOverEvent: null,
                                    onMouseUpEvent: null,
                                    passenger: {},
                                    propComment: '家庭成员失业人数',
                                    propName: 'unemploymentNum',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 500,
                                    valueMinLength: null,
                                    model: 'formData.unemploymentNum',
                                    option: [],
                                    dialog: 0,
                                    autocomplete: 'off',
                                    showWordLimit: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="formData.unemploymentNum" size="mini" resize="none" placeholder="请输入家庭成员失业人数"></el-input> -->
                            <span v-else>{{ formData.unemploymentNum }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="11">
                            <div class="checkbox-line">
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="0" />
                                        脱贫家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="1" />
                                        脱贫不稳定家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="2" />
                                        边缘易致贫家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="3" />
                                        突发严重困难户学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="4" />
                                        特困供养人员
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="5" />
                                        特困职工子女
                                    </label>
                                </span>
                            </div>
                            <div class="checkbox-line">
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="6" />
                                        原广东省户籍建档立卡家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="7" />
                                        最低生活保障家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="8" />
                                        支出型困难家庭学生
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="9" />
                                        低保边缘
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="10" />
                                        孤儿（含事实无人抚养等儿童）
                                    </label>
                                </span>
                            </div>
                            <div class="checkbox-line">
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="11" />
                                        享受国家定期抚恤补助的优抚对象（含烈士子女、牺牲军人子女）、因公牺牲警察子女
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="12" />
                                        父母一方抚养
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.familySituation" type="checkbox" value="13" />
                                        父母一方为残疾人
                                    </label>
                                </span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="label">
                            健康状况
                        </td>
                        <td colspan="11">
                            <div class="checkbox-line">
                                <span>
                                    <label>
                                        <input v-model="formData.healthStatus" type="checkbox" value="0" />
                                        本人残疾
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.healthStatus" type="checkbox" value="1" />
                                        本人或家庭成员患重大疾病
                                    </label>
                                </span>
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <td class="section" :rowspan="2">
                            家庭信息
                        </td>
                        <td class="label"><span class="required">*</span>户籍地址</td>
                        <td colspan="11">
                            <form-item
                                v-if="canEdit"
                                ref="householdRegistration"
                                :field="{
                                    cssClass: null,
                                    cssStyle: null,
                                    defaultValue: null,
                                    elementCanEdit: '{{canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: null,
                                    elementReadonly: 0,
                                    elementType: 'input',
                                    emptyMessage: '请输入户籍地址',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 1,
                                    onBlurEvent: null,
                                    onChangeEvent: null,
                                    onClickEvent: null,
                                    onDblClickEvent: null,
                                    onFocusEvent: null,
                                    onKeyDownEvent: null,
                                    onKeyPressEvent: null,
                                    onKeyUpEvent: null,
                                    onMouseDownEvent: null,
                                    onMouseOverEvent: null,
                                    onMouseUpEvent: null,
                                    passenger: {},
                                    propComment: '户籍地址',
                                    propName: 'householdRegistration',
                                    propType: 'String',
                                    textFormatter: 'textfield',
                                    valueMaxLength: 500,
                                    valueMinLength: null,
                                    model: 'formData.householdRegistration',
                                    option: [],
                                    dialog: 0,
                                    autocomplete: 'off',
                                    showWordLimit: false
                                }"
                                :vo="formData"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="formData.householdRegistration" size="mini" resize="none" placeholder="请输入户籍地址"></el-input> -->
                            <span v-else>{{ formData.householdRegistration }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="label">邮政编码</td>
                        <td colspan="2">{{ formData.postalCode }}</td>
                        <td class="label">联系电话</td>
                        <td colspan="2">{{ formData.familyContactPhone }}</td>
                        <td class="label">家庭人均年收入</td>
                        <td colspan="5">{{ formData.perCapitaIncome }}</td>
                    </tr>

                    <tr>
                        <td class="section" :rowspan="10">家庭成员情况（直系亲属，含祖父母）</td>
                        <td>姓名</td>
                        <td>年龄</td>
                        <td>与学生关系</td>
                        <td colspan="2">工作(学习)单位</td>
                        <td>联系电话</td>
                        <td colspan="2">从业情况</td>
                        <td>文化程度</td>
                        <td>年收入(元)</td>
                        <td>健康状况</td>
                        <td>是否户主</td>
                    </tr>
                    <tr v-for="(m, idx) in formData.passenger.familyMembers" :key="idx">
                        <td>
                            <el-input v-if="canEdit" v-model="m.familyMemberName" size="mini"></el-input>
                            <span v-else>{{ m.familyMemberName }}</span>
                        </td>
                        <td>
                            <el-input v-if="canEdit" v-model="m.age" size="mini"></el-input>
                            <span v-else>{{ m.age }}</span>
                        </td>
                        <td>
                            <form-item
                                ref="relationship"
                                :field="{
                                    defaultValue: null,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: '0：父女\n1：母女\n2：母子\n3：父子\n4：兄弟\n5：兄妹\n6：姐妹\n7：姐弟\n8：舅甥\n9：祖孙\n10：外祖孙\n11：姑侄\n12：叔侄\n13：姨甥\n14：其他',
                                    elementReadonly: 1,
                                    elementType: 'select',
                                    emptyMessage: '请选择称谓',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '称谓',
                                    propName: 'relationship',
                                    propType: 'String',
                                    textFormatter: null,
                                    valueMaxLength: 4,
                                    valueMinLength: null,
                                    model: 'm.relationship',
                                    option: [
                                        {
                                            value: '0',
                                            name: '父女'
                                        },
                                        {
                                            value: '1',
                                            name: '母女'
                                        },
                                        {
                                            value: '2',
                                            name: '母子'
                                        },
                                        {
                                            name: '父子',
                                            value: '3'
                                        },
                                        {
                                            name: '兄弟',
                                            value: '4'
                                        },
                                        {
                                            name: '兄妹',
                                            value: '5'
                                        },
                                        {
                                            name: '姐妹',
                                            value: '6'
                                        },
                                        {
                                            name: '姐弟',
                                            value: '7'
                                        },
                                        {
                                            name: '舅甥',
                                            value: '8'
                                        },
                                        {
                                            name: '祖孙',
                                            value: '9'
                                        },
                                        {
                                            name: '外祖孙',
                                            value: '10'
                                        },
                                        {
                                            name: '姑侄',
                                            value: '11'
                                        },
                                        {
                                            name: '叔侄',
                                            value: '12'
                                        },
                                        {
                                            name: '姨甥',
                                            value: '13'
                                        },
                                        {
                                            name: '其他',
                                            value: '14'
                                        }
                                    ],
                                    optionGenerateType: 0,
                                    clearable: false,
                                    filterable: false,
                                    allowCreate: false
                                }"
                                :vo="m"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="m.relationship" size="mini"></el-input>
                        <span v-else>{{ m.relationship }}</span> -->
                        </td>
                        <td colspan="2">
                            <el-input v-if="canEdit" v-model="m.workUnit" size="mini"></el-input>
                            <span v-else>{{ m.workUnit }}</span>
                        </td>
                        <td>
                            <el-input v-if="canEdit" v-model="m.phone" size="mini"></el-input>
                            <span v-else>{{ m.phone }}</span>
                        </td>
                        <td colspan="2">
                            <el-input v-if="canEdit" v-model="m.workSituation" size="mini"></el-input>
                            <span v-else>{{ m.workSituation }}</span>
                        </td>
                        <td>
                            <el-input v-if="canEdit" v-model="m.whcd" size="mini"></el-input>
                            <span v-else>{{ m.whcd }}</span>
                        </td>
                        <td>
                            <el-input v-if="canEdit" v-model="m.yearIncome" size="mini"></el-input>
                            <span v-else>{{ m.yearIncome }}</span>
                        </td>
                        <td>
                            <el-input v-if="canEdit" v-model="m.healthStatus" size="mini"></el-input>
                            <span v-else>{{ m.healthStatus }}</span>
                        </td>
                        <td>
                            <form-item
                                ref="ifHz"
                                :field="{
                                    defaultValue: 2,
                                    elementCanEdit: '{${canEdit}}',
                                    elementCssHeight: null,
                                    elementCssWidth: null,
                                    elementFormatter: '1：是\n2：否',
                                    elementReadonly: 1,
                                    elementType: 'select',
                                    emptyMessage: '请选择',
                                    errorMessage: null,
                                    formTdAlign: 'text-left',
                                    formTdColspan: 0,
                                    isRequired: 0,
                                    onClickEvent: null,
                                    passenger: {},
                                    propComment: '',
                                    propName: 'ifHz',
                                    propType: 'String',
                                    textFormatter: null,
                                    valueMaxLength: 4,
                                    valueMinLength: null,
                                    model: 'm.ifHz',
                                    option: [
                                        {
                                            value: '1',
                                            name: '是'
                                        },
                                        {
                                            value: '2',
                                            name: '否'
                                        },
                                    ],
                                    optionGenerateType: 0,
                                    clearable: false,
                                    filterable: false,
                                    allowCreate: false
                                }"
                                :vo="m"
                                :can-edit="canEdit"
                            />
                            <!-- <el-input v-if="canEdit" v-model="m.relationship" size="mini"></el-input>
                        <span v-else>{{ m.relationship }}</span> -->
                        </td>
                    </tr>
                    <tr>
                        <td class="section" rowspan="1">影响家庭经济状况有关信息</td>
                        <td colspan="12">
                            <div style="padding-bottom: 10px">家庭主要收入来源类型（只需勾选一项）</div>
                            <div class="checkbox-grid">
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="0" />
                                        工资、奖金、津贴、补贴和其他劳动收入
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="1" />
                                        离退休金、基本养老金、基本生活费、失业保险金
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="2" />
                                        继承、接受赠予、出租或出售家庭财产获得的收入
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="3" />
                                        存款及利息，有价证券及红利、股票、博彩等收入
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="4" />
                                        经商、办厂以及从事种植业、养殖业、加工业扣除必要成本后的收入
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="5" />
                                        赡养费、抚(扶)养费
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="6" />
                                        自谋职业收入
                                    </label>
                                </span>
                                <span>
                                    <label>
                                        <input v-model="formData.incomeSourceType" type="radio" value="7" />
                                        其他应当计入家庭的收入
                                    </label>
                                </span>
                            </div>
                            <br />
                            <div style="display: flex; align-items: center; padding-bottom: 10px">
                                <span>
                                    如无以下情形，请填写“无”，如有以下情形，请勾选
                                    <input style="margin-left: 8px" type="checkbox" disabled />
                                </span>
                            </div>
                            <div class="aligned-form-section">
                                <div class="form-row">
                                    <span style="white-space: nowrap">1.突发事件：</span>
                                    <div class="checkbox-line">
                                        <span>
                                            <label>
                                                <input v-model="formData.suddenEvents" type="checkbox" value="0" />
                                                家庭遭受疫情；
                                            </label>
                                        </span>
                                        <span>
                                            <label>
                                                <input v-model="formData.suddenEvents" type="checkbox" value="1" />
                                                家庭遭受自然灾害；
                                            </label>
                                        </span>
                                        <span>
                                            <label>
                                                <input v-model="formData.suddenEvents" type="checkbox" value="2" />
                                                家庭遭受突发意外事件；
                                            </label>
                                        </span>
                                        <span>
                                            <label>
                                                <input v-model="formData.suddenEvents" type="checkbox" value="3" />
                                                家庭欠债；
                                            </label>
                                        </span>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <span style="margin-left: 20px">具体时间：</span>
                                    <template v-if="canEdit">
                                        <el-date-picker v-model="formData.specificTime" style="width: 100%" type="date" class="date-input" value-format="yyyy-MM-dd"></el-date-picker>
                                    </template>
                                    <template v-else>
                                        <div style="line-height: 26px">{{ datePickerValue }}</div>
                                    </template>
                                    <!-- <input type="date" name="specificTime" v-model="formData.specificTime" class="date-input" /> -->
                                </div>
                                <div class="form-row">
                                    <span style="margin-left: 20px">描述情况内容、金额：</span>
                                    <el-input v-if="canEdit" v-model="formData.situationDes" size="mini" resize="none" placeholder="请输入描述情况内容、金额" class="amount-input"></el-input>
                                    <span v-else>{{ formData.situationDes }}</span>
                                </div>
                                <div class="form-row">
                                    <span>2. 其他情况：</span>
                                    <el-input v-if="canEdit" v-model="formData.otherSituation" style="margin-left: 10px; margin-right: 10px; width: 99%" type="textarea" size="mini" resize="none" placeholder="请输入其他情况" class="other-textarea"></el-input>
                                    <span v-else>{{ formData.otherSituation }}</span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="section" rowspan="1">佐证材料</td>
                        <td colspan="12">
                            <div style="padding-top: 24px; padding-left: 10px; height: 100px">学生或监护人填写所提交的证件名称和相关佐证材料：</div>
                        </td>
                    </tr>
                    <tr>
                        <td class="section" rowspan="2">签章</td>
                        <td colspan="12" class="label">学生本人已满16周岁，只需本人签名；学生本人未满16周岁，需由学生家长或监护人签名。</td>
                    </tr>
                    <tr>
                        <td colspan="6">
                            <div class="signature-section">
                                <div class="signature-left">
                                    <p style="line-height: 32px">本人承诺以上所填资料真实、准确，并同意授权相关部门通过信息核对，对所填资料进行查询、核对。如虚报资料，本人愿意承担相关责任。</p>
                                    <div class="signature-area" style="display: flex; flex-direction: column; align-items: flex-end; padding-right: 40px">
                                        <p style="padding-bottom: 30px; margin: 0; padding-right: 100px">手写签名：</p>
                                        <p style="margin: 0">　　年　　月　　日</p>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td colspan="6">
                            <div class="signature-right">
                                <p style="line-height: 32px">本人是 学生的（□父亲 □母亲 □监护人），以上所填资料真实、准确，同意授权相关部门通过信息核对，对所填资料进行查询、核对。如虚报资料，本人愿意承担相关责任。</p>
                                <div class="signature-area" style="display: flex; flex-direction: column; align-items: flex-end; padding-right: 40px">
                                    <p style="padding-bottom: 30px; margin: 0; padding-right: 100px">学生家长或监护人手写签名：</p>
                                    <p style="margin: 0">　　年　　月　　日</p>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="footer-notes" style="display: flex">
            <p><strong>注：</strong></p>
            <div>
                <p>1. 本表供学生根据需要申请家庭经济困难认定用，可复印。请如实填写，此表连同相关佐证材料交到学校。</p>
                <p>2. 家庭成员健康状况主要填写是否患重大疾病，是否残疾及等级。</p>
                <p>3. 选择性项目必须填写。</p>
                <p>4. 涂改无效。</p>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment'
export default {
    name: 'Knxsrdb',
    props: {
        value: {
            type: Object,
            default: null
        },
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            formData: {
                title: '广东省家庭经济困难学生认定申请表',
                orgName: '',
                institutionName: '', //学校
                grade: '',
                className: '', //班级
                studentId: '', //学(籍)号
                name: '',
                gender: '', //性别
                ethnicity: '', //民族（56个民族）
                birthDate: '', //出生年月
                idCardNumber: '', //身份证号
                hukouNature: '', //户口性质
                majorCategory: '', //院系
                college: '',
                major: null,
                majorCategoryId: null,
                majorId: null,
                majorName: null,
                majorSubcategory: null,
                majorSubcategoryId: null,
                majorVersion: null,
                population: '', //家庭人口数
                learningNum: '', //家庭成员在学人数
                supportNum: '', //赡养人数
                unemploymentNum: '', //家庭成员失业人数
                familySituation: [], //家庭情况
                healthStatus: [], //健康状况
                householdRegistration: '', //户籍地址
                postalCode: '', //邮政编码
                familyContactPhone: '', //联系电话
                perCapitaIncome: '', //家庭人均年收入
                passenger: {
                    familyMembers: [
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' },
                        { familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' }
                    ],
                    attachments: []
                },
                incomeSourceType: '', //家庭主要收入来源类型
                suddenEvents: [], //突发事件
                specificTime: '', //具体时间
                situationDes: '', //描述情况内容、金额
                otherSituation: '', //其他情况
                studentBasicInfoId: '' //学生基本信息id
            },
            datePickerValue: '',
            requestUrl: '/xsgl/studentDifficultApply/insert',
            requestMethod: 'post',
            canEdit: 0,
            isNew: false
        }
    },
    computed: {},
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.formData = { ...this.formData, ...val }
                }
            }
        }
    },
    created() {
        this.datePickerValue = moment(this.formData.specificTime).format('YYYY-MM-DD')
        this.moment = moment
        console.log('created this.formData', JSON.parse(JSON.stringify(this.formData)))
    },
    mounted() {
        document.getElementsByClassName('el-table--border')[0].classList.remove('el-table--border')
        if (this.$route.query.canEdit) {
            this.canEdit = Number(this.$route.query.canEdit)
        }
        if (this.$route.query.isNew) {
            this.isNew = this.$route.query.isNew === 'true'
        }
        if (!this.isNew) {
            if (this.vo && typeof this.vo === 'object') {
                const vo = { ...this.vo }
                ;['familySituation', 'suddenEvents', 'healthStatus'].forEach((key) => {
                    if (vo[key] && typeof vo[key] === 'string') {
                        try {
                            vo[key] = JSON.parse(vo[key])
                        } catch (e) {
                            vo[key] = []
                        }
                    } else if (!vo[key]) {
                        vo[key] = []
                    }
                })
                this.formData = { ...this.formData, ...vo }
                if (this.formData.passenger.familyMembers.length < 9) {
                    for (let i = this.formData.passenger.familyMembers.length; i < 9; i++) {
                        this.formData.passenger.familyMembers.push({ familyMemberName: '', age: '', relationship: '', workUnit: '', phone: '', workSituation: '', whcd: '', yearIncome: '', healthStatus: '' })
                    }
                }
            }
        }
        console.log('mounted this.formData', JSON.parse(JSON.stringify(this.formData)))
    },
    methods: {
        onBasicFormBeforeSubmit: function ($scope, vo, defer) {
        },
        onSelectListpageRowCompleted: function (val, arr) {
            const item = val[0]
            delete item.hukouNature
            item.healthStatus = [item.healthStatus]
            console.log('student item:', JSON.parse(JSON.stringify(item)))
            // 选择学生后，将id赋值给studentBasicInfoId
            this.formData.studentBasicInfoId = item.id

            // 入学年份 = 年级（应该）
            this.formData.grade = item.admissionYear
            if (item.passenger && Array.isArray(item.passenger.familyMembers)) {
                const newMembers = item.passenger.familyMembers
                const isAllEmpty = newMembers.every((m) => {
                    return !m || (typeof m === 'object' && Object.values(m).every((v) => v === ''))
                })
                if (!isAllEmpty) {
                    // 只替换前n项
                    const n = newMembers.length
                    for (let i = 0; i < n; i++) {
                        this.formData.passenger.familyMembers[i] = { ...newMembers[i] }
                    }
                }
                const { familyMembers, ...otherPassenger } = item.passenger
                this.formData.passenger = { ...this.formData.passenger, ...otherPassenger }
            }
            // 合并除passenger外的其他属性，为null的不合并
            const { passenger, ...otherItem } = item
            for (const key in otherItem) {
                if (otherItem.hasOwnProperty(key)) {
                    if (otherItem[key] !== null && otherItem[key] !== undefined) {
                        this.formData[key] = otherItem[key]
                    }
                }
            }
            console.log('this.formData', JSON.parse(JSON.stringify(this.formData)))
            this.getFamilyList(this.formData.studentId)
        },
        // 判断必填字段是否为空
        async saveData() {
            this.formValidate(async () => {
                if (this.isNew === true) {
                    this.requestUrl = '/xsgl/studentDifficultApply/insert'
                    this.requestMethod = 'post'
                } else {
                    this.requestUrl = '/xsgl/studentDifficultApply/update'
                    this.requestMethod = 'put'
                }
                console.log('requestUrl、requestMethod', this.requestUrl, this.requestMethod)
                const formData = {
                    ...this.formData,
                    flCreator: this.$store.getters.loginUser.personName
                }
                const res = await this.$http({
                    url: this.requestUrl,
                    method: this.requestMethod,
                    data: formData
                })
                const { code, message, body } = res
                if (code === 'success') {
                    this.$message.success('保存成功')
                    if (this.isNew === true) {
                        this.isNew = false
                        console.log('this.isNew', this.isNew)
                    }
                    const id = body.vo.id
                    // 替换url上query的void的值
                    // 直接修改 query 对象
                    const newQuery = { ...this.$route.query, voId: id, isNew: 'false' }
                    // 更新路由
                    this.$router.push({ query: newQuery })
                    // params.set(voId, id);
                    // location.replace(urlObj.origin + urlObj.pathname + '?' + params)
                    setTimeout(() => {
                        location.reload()
                    }, 200)
                } else {
                    this.$message.error(message)
                }
            })
        },
        async getFamilyList(id) {
            const formData = new FormData()
            formData.append('pageSize', 10000)
            formData.append('pageNum', 1)
            formData.append('listpageId', 'f6a88cbff3e64b80b1500405a973ab58')
            formData.append('urlsearch', `studentId:${id};relationship!:14`)
            const { code, message, body } = await this.$http({
                method: 'post',
                url: '/xsgl/studentFamilyMembers/listdata',
                data: formData
            })
            if (code == 'success') {
                for (let i = 0; i < this.formData.passenger.familyMembers.length; i++) {
                    const item = this.formData.passenger.familyMembers[i]
                    const dataItem = body.pageInfo.list[i]
                    if (!body.pageInfo.list[i]) {
                        this.$set(item, 'familyMemberName', '')
                        this.$set(item, 'age', '')
                        this.$set(item, 'relationship', '')
                        this.$set(item, 'workUnit', '')
                        this.$set(item, 'phone', '')
                        this.$set(item, 'ifHz', '2')
                    } else {
                        this.$set(item, 'familyMemberName', dataItem.familyMemberName)
                        this.$set(item, 'age', dataItem.age)
                        this.$set(item, 'relationship', dataItem.relationship)
                        this.$set(item, 'workUnit', dataItem.workUnit)
                        this.$set(item, 'phone', dataItem.phone)
                        this.$set(item, 'ifHz', dataItem.ifHz)
                    }
                    // this.$set(item, 'workSituation', dataItem.familyMemberName)
                    // this.$set(item, 'yearIncome', dataItem.familyMemberName)
                    // this.$set(item, 'healthStatus', dataItem.familyMemberName)
                }
                // this.$set(this.vo.passenger, 'familyMembers', body.list)
            } else {
                this.$message.error(message)
            }
        }
    }
}
</script>

<style scoped lang="scss">
.knxsrdb {
    width: 100%;
}

.grid {
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
}

.grid td,
.grid th {
    border: 1px solid #333;
    padding: 6px 8px;
    word-break: break-all;
}

.grid .title {
    font-size: 20px;
    text-align: center;
    border: none;
    padding: 14px 0;
}

.grid .section {
    width: 120px;
    text-align: center;
    font-weight: 700;
}

.grid .label {
    width: 120px;
    text-align: center;
}

.inner {
    width: 100%;
}

.inner .inner-head td {
    font-weight: 600;
    text-align: center;
}

.no-padding {
    padding: 0;
}

.form-row {
    margin: 10px 0;
    display: flex;
    align-items: center;
}

.date-input,
.amount-input {
    padding: 4px 8px;
    border: 1px solid #ccc;
    margin: 0 10px;
}

.description-textarea,
.other-textarea {
    width: 100%;
    min-height: 60px;
    padding: 8px;
    border: 1px solid #ccc;
    resize: vertical;
}

.signature-section {
    display: flex;
    justify-content: space-between;
}

.signature-left,
.signature-right {
    width: 100%;
    padding: 10px;
}

.signature-area {
    margin-top: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.footer-notes {
    padding: 15px;
}

.footer-notes p {
    margin: 5px 0;
    line-height: 1.6;
}

.el-table thead {
    color: #333333;
}

.checkbox-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px 10px;
}

.aligned-form-section {
    display: grid;
    grid-template-columns: max-content 1fr;
    row-gap: 10px;
    align-items: center;
    padding-left: 20px;
}

.aligned-form-section .form-row {
    display: contents;
}

.checkbox-line {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 5px 50px;
    padding: 5px;
}

/deep/.el-form .el-table::before {
    background-color: #fff !important;
}
/deep/.el-table--border::after,
.el-table--group::after,
/deep/.el-table::before {
    background-color: #999;
}

.required {
    color: red;
    margin-right: 4px;
}

/deep/ .el-table--border{
    border: none !important;
}
</style>
